// 小屏-会议室
<template>
  <div class="DkbSMR">
    <!-- 柱状图 -->
    <div id="MRChart"></div>
  </div>
</template>

<script>
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  import { showToast } from "../../../../static/js/utility/utility.js"
  let echarts = require('echarts')
  let vm, Timer

  export default {
    name: 'DkbSMR',
    components: {
    },
    props: {
      // 父组件传来的参数
      sData: {
        type: Object,
        default: {}
      }
    },
    computed: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
    },
    mounted() {
      // console.log('route', this.$route)
      vm.$nextTick(()=>{
        vm.getMRChart()
      })
      vm.timeRefresh() 
    },
    destroyed () {
      clearInterval(Timer)
    },
    methods: {
      // 定时刷新数据
      timeRefresh () {
        Timer = setInterval(()=>{
          vm.GetMRInfo()
        }, 1000*5*60)
      },
      // 获取会议室信息（小屏）
      async GetMRInfo () {
        let res = await dkbApi.GetMRInfo()
        if (res.ErrCode === 0) {
          vm.sData = res.Result
          vm.$nextTick(()=>{
            vm.getMRChart()
          })
        } else {
          showToast(res.meta.ErrMsg)
        }
      },
      // 获取柱状图表
      getMRChart () {
        let myChart = echarts.init(document.getElementById('MRChart'))
        let htmlFontSize = vm.$store.state.htmlFontSize
        let xData = ['在线会议室数量', '正在使用会议室数量', '今日总预约会议数']
        let { OnlineNum, InUseNum, TodayTotal} = vm.sData

        let option = {
          tooltip : {
            trigger: 'axis',
            axisPointer : {          // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: 0,
            right: 0,
            // top: 0,
            top: (12/100)*htmlFontSize,
            bottom: 0,
            containLabel: true
          },
          xAxis : [
            {
              type : 'category',
              data : xData,
              axisTick: {
                show: false  // 不显示刻度
              },
              axisLine: {
                lineStyle: {
                  color: '#798ea1'  // 坐标轴颜色
                }
              },
              axisLabel: {
                interval: 0,
                color: '#ffffff',
                fontSize: (15/100)*htmlFontSize,
                padding: [(16/100)*htmlFontSize, 0, 0, 0]
              },
            }
          ],
          yAxis : [
            {
              type : 'value',
              min: 0,
              max: 50,
              splitNumber: 10,   //分割段数
              nameGap: (22/100)*htmlFontSize,
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#798ea1'
                }
              },
              axisLabel: {
                interval: 0,
                marginL: 0,
                color: '#ffffff',
                fontSize: (15/100)*htmlFontSize,
                fontWeight: 'lighter',
                padding:[0, (12/100)*htmlFontSize, 0, 0]
              },
              splitLine: {
                lineStyle: {
                  color: '#375773'
                }
              }
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: '0',
              barWidth: (65/100)*htmlFontSize,
              itemStyle: {
                // 柱体背景
                color: function (params) {
                  var colorList = [
                    ['#51b7d4', '#fbfdfe'],
                    ['#e99515', '#fefaf4'],
                    ['#8ebb2c', '#fefffe']
                  ]
                  var index = params.dataIndex
                  //给大于颜色数量的柱体添加循环颜色的判断
                  if (params.dataIndex >= colorList.length) {
                    index = params.dataIndex - colorList.length;
                  }
                  return new echarts.graphic.LinearGradient(0, 1, 0, 0,
                    [
                      {
                        offset: 0,
                        color: colorList[index][0]
                      },
                      {
                        offset: 1,
                        color: colorList[index][1]
                      }
                    ]
                  )
                }
              },
              label: {
                // 柱体上方文字
                normal: {
                  show: true,
                  position: 'top',
                  formatter:'{c}',  //文字显示的格式
                }
              },
              data: [
                {
                  value: OnlineNum,
                  label: {
                    color: '#51b7d4'
                  }
                }, {
                  value: InUseNum,
                  label: {
                    color: '#f39800'
                  }
                }, {
                  value: TodayTotal,
                  label: {
                    color: '#90c31f'
                  }
                }
              ],
            }
          ]
        }
        myChart.setOption(option)
      },
      // 屏幕变化图表自适应加载
      resizeGetChart () {
        echarts.init(document.getElementById('MRChart')).resize()
      }
    },
    watch: {
      // 屏幕变化，图表自适应加载
      '$store.state.isOnresize' (newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.resizeGetChart()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.DkbSMR {
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0.3rem 0.4rem;
  #MRChart{
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/MR.vue